<ng-container *ngIf="link; else button">
  <a class="header-item" [routerLink]="link" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
    <app-icon [name]="icon" [size]="IconSize.Medium"></app-icon>
    <span class="header-item__label">{{ 'sidebar.' + label | translate }}</span>
  </a>
</ng-container>

<ng-template #button>
  <div class="header-item" (click)="action.emit()">
    <app-icon [name]="icon" [size]="IconSize.Medium"></app-icon>
    <span class="header-item__label">{{ 'sidebar.' + label | translate }}</span>
  </div>
</ng-template>


